import { LEARN_SLUGS } from "./slugs";

const STOP = new Set([
  "what", "whats", "is", "are", "the", "a", "an", "of", "to", "my", "i", "do",
  "does", "how", "much", "many", "and", "for", "with", "can", "should", "in",
  "on", "mean", "means", "cause", "causes", "side", "effects", "about", "when",
]);

function tokens(text) {
  return (text || "")
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .split(/\s+/)
    .filter((w) => w.length > 2 && !STOP.has(w));
}

// Pick 2-3 related Health Library topics by keyword overlap.
export function getRelated(question, categoryLabel = "", currentSlug = null, max = 3) {
  const qt = new Set([...tokens(question), ...tokens(categoryLabel)]);
  const scored = LEARN_SLUGS.filter((s) => s.slug !== currentSlug).map((s) => {
    const tt = tokens(s.title);
    let score = 0;
    for (const w of tt) if (qt.has(w)) score += 1;
    return { ...s, score };
  });
  scored.sort((a, b) => b.score - a.score);

  const withHits = scored.filter((s) => s.score > 0).slice(0, max);
  if (withHits.length >= 2) return withHits;
  // Fill with sensible defaults so the section is always useful.
  const fill = scored.filter((s) => !withHits.includes(s)).slice(0, max - withHits.length);
  return [...withHits, ...fill].slice(0, max);
}
